if (!customElements.get("countdown-bar")) {
  const CountdownBar = class extends HTMLElement {
    constructor() {
      super();
      this.countdowns = this.querySelectorAll(".countdown-container");
      if (this.countdowns.length > 1) {
        this.changeDelay = 5000;
        this.currentCountdown = 0;
        this.controller = this.querySelector('.countdown-bar__countdown-controller');
        this.previousBtn = this.querySelector('.countdown-button--previous');
        this.nextBtn = this.querySelector('.countdown-button--next');

        this.mouseEnterHandler = this.pauseCountdowns.bind(this);
        this.addEventListener("mouseenter", this.mouseEnterHandler);
        this.mouseLeaveHandler = this.playCountdowns.bind(this);
        this.addEventListener("mouseleave", this.mouseLeaveHandler);
        this.focusInHandler = this.pauseCountdowns.bind(this);
        this.addEventListener("focusin", this.focusInHandler);
        this.focusOutHandler = this.playCountdowns.bind(this);
        this.addEventListener("focusout", this.focusOutHandler);
        this.clickPrevHandler = this.previousCountdown.bind(this);
        this.previousBtn.addEventListener("click", this.clickPrevHandler);
        this.clickNextHandler = this.nextCountdown.bind(this);
        this.nextBtn.addEventListener("click", this.clickNextHandler);
        this.observer = new IntersectionObserver(this.handleIntersect.bind(this));
        this.observer.observe(this);
      }
      this.expireCountdownHandler = this.expireCountdown.bind(this);
      this.addEventListener("on:countdown-timer:expire", this.expireCountdownHandler);
    }

    disconnectedCallback() {
      if (this.mouseEnterHandler) {
        this.removeEventListener('mouseenter', this.mouseLeaveHandler);
      }
      if (this.mouseLeaveHandler) {
        this.removeEventListener('mouseleave', this.mouseLeaveHandler);
      }
      if (this.focusInHandler) {
        this.removeEventListener('focusin', this.focusInHandler);
      }
      if (this.focusOutHandler) {
        this.removeEventListener('focusout', this.focusOutHandler);
      }
      if (this.clickPrevHandler) {
        this.previousBtn.removeEventListener('click', this.clickPrevHandler);
      }
      if (this.clickNextHandler) {
        this.nextBtn.removeEventListener('click', this.clickNextHandler);
      }
      if (this.expireCountdownHandler) {
        this.removeEventListener('on:countdown-timer:expire', this.expireCountdownHandler);
      }
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.target === this) {
          if (entry.isIntersecting) {
            this.playCountdowns(this);
          } else {
            this.pauseCountdowns(this);
          }
        }
      });
    }

    playCountdowns() {
      if (this.countdowns.length > 1) {
        this.pauseCountdowns();
        this.countdownInterval = setInterval(() => {
          this.setCurrentCountdown(this.currentCountdown + 1);
        }, this.changeDelay);
      }
    }

    pauseCountdowns() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
    }

    expireCountdown(evt) {
      const targetCountdown = evt.target.closest('.countdown-container');
      targetCountdown.classList.add("countdown--expired");
      this.countdowns = this.querySelectorAll('.countdown-container:not(.countdown--expired)');
      if (this.controller && this.countdowns.length <= 1) {
        // Hide nav bar if there is no more than 1 countdown bar
        this.controller.classList.add('hidden');
      }
      // Show the next available countdown - if first loaded, do not toggle background
      const isLoaded = evt.target.hasAttribute('loaded');
      this.setCurrentCountdown(Number(targetCountdown.dataset.index) + 1, isLoaded);
    }

    setCurrentCountdown(newIndex, toggleBackground = true) {

      // positive modulo, like it should be, JS does not do *maths* correctly
      this.currentCountdown = ((newIndex % this.countdowns.length) + this.countdowns.length) % this.countdowns.length;
      this.countdowns.forEach((el, index) => {
        if (index !== this.currentCountdown) {
          el.classList.add("countdown--inactive");
        } else {
          el.classList.remove("countdown--inactive");
        }
      });
      if (toggleBackground && this.countdowns.length > 1) {
        // Alternate the countdown bar background color
        this.classList.toggle('countdown-bar--alt-background');
      }
    }

    previousCountdown() {
      this.setCurrentCountdown(this.currentCountdown - 1);
    }

    nextCountdown() {
      this.setCurrentCountdown(this.currentCountdown + 1);
    }
  };

  window.customElements.define("countdown-bar", CountdownBar);
}
